module.exports = __webpack_public_path__ + "img/Kd.70ced1c2.png";